import { render, staticRenderFns } from "./linkShopsToArticle.vue?vue&type=template&id=414ba258&scoped=true&"
import script from "./linkShopsToArticle.vue?vue&type=script&lang=js&"
export * from "./linkShopsToArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414ba258",
  null
  
)

export default component.exports